module.exports = __webpack_public_path__ + "img/20191012161607134.bf93502d.jpg";